<div class="hearderPadding"></div>
<div class="container">
  <app-display-horizontal-ads-responsive></app-display-horizontal-ads-responsive>
</div>
